import React from "react";
import { CreditCardInfoTemplate } from "themes/application/payment/components";

function CreditCardInfo(props) {
    return <CreditCardInfoTemplate {...props} />;
}

export default CreditCardInfo;
